import { Component, Renderer2, ElementRef, ApplicationRef, Input, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CpqInputBase } from '../cpq-input-base';
import { ActivatedRoute } from '@angular/router';
import {ILabel} from "../ILabel.model";
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'cpq-input',
    templateUrl: './cpq-input.component.html',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: CpqInputComponent,
            multi: true
        }
    ],
    styleUrls: ['../cpq-textarea/cpq-textarea.component.scss', './cpq-input.component.scss'],
    standalone: false
})
export class CpqInputComponent extends CpqInputBase {
  @Input('dynamicWidth') dynamicWidth = false;
  @Input('customClass') customClass = '';
  @Input('showSearchIcon') showSearchIcon = false;
  @Input('tabindex') tabindex?: number;
  @ViewChild('inputField', { static: true }) inputField: ElementRef;
  @Input('infoMessage') infoMessage?: ILabel;

  public placeholder = '';
  constructor(
    public route: ActivatedRoute,
    public ref: ApplicationRef,
    public dialog: MatDialog
  ) {
    super(ref, dialog);
  }
}
